import { getErrorCode } from './getErrorCode';

/**
 * The integration service recognised the exact payload it is already handling:
 *
 * - `DUPLICATE_REQUEST_IN_PROGRESS` - the same payload is still being processed.
 * - `DUPLICATE_REQUEST_ALREADY_PROCESSED` - the same payload went through moments ago.
 *
 * Both mean this very submission reached the backend and is on its way, never
 * that it failed. Showing an error for them is what makes a customer submit
 * again, so a form has to treat them as a submission that landed.
 */
const duplicateSubmissionCodes = ['DUPLICATE_REQUEST_IN_PROGRESS', 'DUPLICATE_REQUEST_ALREADY_PROCESSED'];

/**
 * The market still holds an unprocessed request of this type for the customer.
 *
 * This is NOT the same as a duplicate: it says nothing about the payload just
 * sent, only that an earlier request of the same type is still open. A customer
 * correcting a mistake gets this too, and their correction is not applied - so
 * reporting it as success would tell them a change landed when it did not.
 * Show the pending request instead, which is also what SERVICE.md asks for.
 */
const pendingRequestCode = 'REQUEST_ALREADY_IN_PROGRESS';

export const isDuplicateSubmissionError = (error: unknown): boolean => {
    const code = getErrorCode(error);
    return !!code && duplicateSubmissionCodes.includes(code);
};

export const isPendingRequestError = (error: unknown): boolean => getErrorCode(error) === pendingRequestCode;
